export const DocumentsIllustration = () => (
  <svg
    width="383"
    height="64"
    viewBox="0 0 383 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.3">
      <rect
        x="254.666"
        y="-45.2965"
        width="91.5897"
        height="43.3846"
        rx="7.23077"
        transform="rotate(6 254.666 -45.2965)"
        fill="#9AA2B2"
      />
      <rect
        x="254.666"
        y="-45.2965"
        width="91.5897"
        height="43.3846"
        rx="7.23077"
        transform="rotate(6 254.666 -45.2965)"
        fill="url(#paint0_linear_198_2404)"
      />
    </g>
    <rect
      x="350.549"
      y="-35.2189"
      width="43.3846"
      height="43.3846"
      rx="7.23077"
      transform="rotate(6 350.549 -35.2189)"
      fill="#9AA2B2"
    />
    <rect
      x="350.549"
      y="-35.2189"
      width="43.3846"
      height="43.3846"
      rx="7.23077"
      transform="rotate(6 350.549 -35.2189)"
      fill="url(#paint1_linear_198_2404)"
    />
    <g clipPath="url(#clip0_198_2404)">
      <path
        opacity="0.4"
        d="M369.515 -24.4402C370.199 -24.3693 370.803 -24.3066 371.352 -24.0445C371.465 -23.9905 371.575 -23.9305 371.682 -23.8647C372.199 -23.5453 372.581 -23.0701 373.012 -22.5332L378.139 -16.1686C378.64 -15.5484 379.085 -14.998 379.285 -14.318C379.485 -13.6381 379.41 -12.9326 379.325 -12.1376L379.143 -10.402L365.027 -11.8856C364.562 -11.9283 364.079 -11.8367 363.64 -11.5933C362.476 -10.9481 362.055 -9.48115 362.7 -8.31682L363.665 -6.57581L362.359 -5.07343C361.486 -4.06867 361.593 -2.54631 362.597 -1.67314C362.977 -1.34372 363.429 -1.15376 363.893 -1.09888L376.643 0.241224C376.524 0.361719 376.398 0.477191 376.262 0.587514C375.228 1.42924 374.008 1.7098 372.59 1.75181C371.224 1.79227 369.511 1.61225 367.387 1.3889C365.262 1.16561 363.379 0.967721 362.051 0.644121C360.672 0.308146 359.537 -0.219923 358.701 -1.25823C357.865 -2.29653 357.587 -3.52237 357.547 -4.94784C357.508 -6.3208 357.689 -8.04226 357.913 -10.178L357.913 -10.178L358.489 -15.6595L358.489 -15.6596C358.683 -17.4977 358.838 -18.9797 359.099 -20.1445C359.369 -21.3496 359.781 -22.3633 360.584 -23.1742C360.879 -23.4718 361.205 -23.737 361.556 -23.9651C362.512 -24.5864 363.583 -24.7804 364.812 -24.7953C366 -24.8096 367.687 -24.6324 369.515 -24.4402Z"
        fill="white"
      />
    </g>
    <g opacity="0.3">
      <rect
        x="9.92236"
        y="-22.5495"
        width="43.3846"
        height="43.3846"
        rx="7.23077"
        transform="rotate(6 9.92236 -22.5495)"
        fill="#9AA2B2"
      />
      <rect
        x="9.92236"
        y="-22.5495"
        width="43.3846"
        height="43.3846"
        rx="7.23077"
        transform="rotate(6 9.92236 -22.5495)"
        fill="url(#paint2_linear_198_2404)"
      />
    </g>
    <rect
      x="57.8635"
      y="-17.5107"
      width="43.3846"
      height="43.3846"
      rx="7.23077"
      transform="rotate(6 57.8635 -17.5107)"
      fill="#9AA2B2"
    />
    <rect
      x="57.8635"
      y="-17.5107"
      width="43.3846"
      height="43.3846"
      rx="7.23077"
      transform="rotate(6 57.8635 -17.5107)"
      fill="url(#paint3_linear_198_2404)"
    />
    <path
      opacity="0.4"
      d="M78.029 -6.60562C78.7122 -6.53473 79.3169 -6.47199 79.8655 -6.20995C79.9786 -6.15595 80.0887 -6.09591 80.1953 -6.03009C80.7129 -5.71071 81.0947 -5.23548 81.526 -4.6986L86.6527 1.66599C87.1538 2.28619 87.5986 2.83663 87.7986 3.51656C87.9987 4.19649 87.9235 4.90201 87.8387 5.69695L87.8137 5.9346C87.6355 7.62951 87.5464 8.47696 86.9645 8.94815C86.3826 9.41934 85.5351 9.33027 83.8402 9.15213L70.0573 7.70347C68.3624 7.52532 67.5149 7.43624 67.0437 6.85434C66.5724 6.27243 66.6615 5.42495 66.8397 3.72998L67.0031 2.175C67.1963 0.336874 67.352 -1.14513 67.6129 -2.3099C67.8829 -3.51505 68.2944 -4.52872 69.0978 -5.33959C69.3926 -5.63724 69.7183 -5.90237 70.0692 -6.13047C71.0252 -6.75185 72.0971 -6.94579 73.3258 -6.96067C74.5133 -6.97505 76.2004 -6.79784 78.029 -6.60562Z"
      fill="white"
    />
    <path
      d="M67.7026 9.27337C70.1184 9.52749 71.7686 11.7883 71.5132 14.2183C71.2577 16.6482 69.1735 18.5166 66.7577 18.2629C66.7479 18.2619 66.7375 18.2608 66.7276 18.2597C66.5428 18.2404 66.346 18.2194 66.1787 18.1854C65.9881 18.1466 65.7485 18.075 65.5222 17.9013C65.081 17.5625 64.943 17.1025 64.9124 16.7424C64.8898 16.4751 64.9238 16.1862 64.943 16.0219C64.9461 15.9951 64.9493 15.9716 64.9513 15.9521L65.4552 11.1581C65.4572 11.1387 65.4591 11.1149 65.4616 11.0881C65.4769 10.9235 65.5037 10.6338 65.5815 10.377C65.6862 10.0311 65.9168 9.60991 66.4188 9.37018C66.6764 9.24726 66.9255 9.22716 67.1201 9.22884C67.2909 9.23033 67.5177 9.25389 67.7026 9.27337ZM76.7591 10.2253C77.2434 10.2761 77.7532 10.3301 78.1191 10.4222C78.5299 10.5256 78.9556 10.7135 79.273 11.1307C79.584 11.5395 79.6607 11.9984 79.6697 12.4204C79.6778 12.8088 79.6283 13.2812 79.5736 13.8017L79.3108 16.3016C79.2562 16.8222 79.2064 17.2945 79.1176 17.6727C79.0211 18.0837 78.8507 18.5166 78.4615 18.8518C78.0643 19.1938 77.6088 19.2891 77.1854 19.3049C76.8084 19.3189 76.2986 19.2658 75.8143 19.2148C75.3301 19.164 74.8211 19.11 74.4554 19.018C74.0445 18.9145 73.6188 18.7266 73.3014 18.3095C72.9904 17.9007 72.9137 17.4418 72.9048 17.0197C72.8966 16.6313 72.9461 16.159 73.0008 15.6384L73.2636 13.1385C73.3183 12.618 73.3681 12.1456 73.4568 11.7674C73.5533 11.3564 73.7237 10.9235 74.1129 10.5883C74.5102 10.2463 74.9656 10.151 75.389 10.1352C75.7659 10.1212 76.275 10.1743 76.7591 10.2253ZM84.6959 11.0594C85.0063 11.0921 85.3419 11.1291 85.6531 11.1924C85.9634 11.2556 86.3085 11.356 86.6233 11.5468C86.9561 11.7484 87.2379 12.0412 87.4136 12.4449C87.582 12.8317 87.628 13.2622 87.6006 13.7116C87.5702 14.2098 87.1417 14.5889 86.6435 14.5586C86.1453 14.5282 85.7662 14.0998 85.7966 13.6015C85.8128 13.3346 85.7755 13.2112 85.7559 13.1662C85.7435 13.1378 85.7315 13.1202 85.687 13.0931C85.6242 13.0551 85.5065 13.0079 85.292 12.9642C85.0784 12.9207 84.826 12.8907 84.5069 12.8572C83.5174 12.7532 83.3317 12.8861 83.2989 12.9158C83.2819 12.9312 83.2227 12.9927 83.1572 13.2082C83.0895 13.4313 83.0356 13.7486 82.9868 14.2125L82.7349 16.6095C82.6861 17.0734 82.6729 17.395 82.6927 17.6272C82.712 17.8521 82.7573 17.9245 82.7705 17.9428C82.7964 17.9786 82.9506 18.1463 83.9401 18.2503C84.2591 18.2838 84.5122 18.3079 84.7302 18.3098C84.9491 18.3116 85.074 18.29 85.1433 18.2658C85.1925 18.2486 85.208 18.2337 85.2259 18.2087C85.2545 18.1687 85.3167 18.0549 85.3563 17.7903C85.4304 17.2969 85.8902 16.9565 86.3837 17.0303C86.8772 17.1042 87.2174 17.5643 87.1438 18.0578C87.0772 18.5032 86.9427 18.9154 86.6974 19.2589C86.4416 19.6171 86.1051 19.845 85.7377 19.973C85.3901 20.0941 85.0316 20.1206 84.715 20.1179C84.3975 20.1152 84.0614 20.0816 83.7511 20.049C82.8008 19.9491 81.8493 19.7544 81.3052 19.0014C81.0334 18.6253 80.928 18.1963 80.8924 17.7807C80.8574 17.3718 80.8856 16.9117 80.9372 16.4205L81.1891 14.0236C81.2407 13.5323 81.309 13.0756 81.4282 12.6828C81.5494 12.284 81.7419 11.8868 82.0857 11.5756C82.7744 10.9522 83.7456 10.9596 84.6959 11.0594ZM67.2843 11.048L66.7176 16.4401C66.7249 16.4409 66.8579 16.4549 66.9468 16.4642C68.2686 16.6029 69.5525 15.5705 69.7145 14.0293C69.8765 12.4879 68.8354 11.2102 67.5136 11.0711C67.4247 11.0617 67.2916 11.0487 67.2843 11.048ZM76.5702 12.023C76.0118 11.9643 75.6887 11.9326 75.4564 11.9413C75.3568 11.945 75.3086 11.9557 75.2904 11.9611C75.2886 11.964 75.2861 11.9682 75.2831 11.9741C75.2684 12.0027 75.2438 12.063 75.2163 12.1802C75.1568 12.4335 75.1178 12.7901 75.0559 13.3789L74.804 15.7759C74.7421 16.3648 74.7061 16.7216 74.7116 16.9818C74.7141 17.1016 74.7258 17.1652 74.7342 17.1963C74.736 17.2028 74.7374 17.2083 74.7385 17.2115C74.7553 17.2206 74.8002 17.2411 74.8968 17.2654C75.1222 17.3222 75.445 17.3574 76.0034 17.4161C76.562 17.4748 76.8857 17.5075 77.118 17.4989C77.2176 17.4952 77.2658 17.4845 77.2841 17.479C77.2859 17.4761 77.2884 17.4711 77.2914 17.4651C77.3061 17.4364 77.3308 17.3766 77.3581 17.26C77.4176 17.0066 77.4566 16.6501 77.5185 16.0612L77.7704 13.6643C77.8323 13.0754 77.8683 12.7185 77.8628 12.4583C77.8603 12.3381 77.8487 12.2739 77.8403 12.2429C77.8386 12.2365 77.837 12.2318 77.8359 12.2287C77.8192 12.2195 77.7742 12.199 77.6776 12.1747C77.4521 12.118 77.1289 12.0817 76.5702 12.023ZM79.1073 -6.45466C79.3721 -6.39887 79.6247 -6.32224 79.8659 -6.20702C79.9788 -6.15306 80.089 -6.09279 80.1955 -6.02704C80.713 -5.70766 81.0943 -5.23196 81.5255 -4.69518L86.6531 1.66863C87.1542 2.28876 87.5988 2.83941 87.7989 3.51924C87.8871 3.81888 87.9212 4.1238 87.9252 4.43884L85.5515 4.18936C83.9125 4.01712 83.135 3.93521 82.1106 3.68631C81.0471 3.42788 80.1712 3.02174 79.5256 2.22451C78.8801 1.42728 78.6649 0.486092 78.6332 -0.607926C78.6028 -1.65933 78.6849 -2.4356 78.8564 -4.06742L79.1073 -6.45466Z"
      fill="white"
    />
    <g opacity="0.3">
      <rect
        x="106.609"
        y="-11.4785"
        width="41.5769"
        height="41.5769"
        rx="6.32692"
        transform="rotate(6 106.609 -11.4785)"
        stroke="#9AA2B2"
        strokeWidth="1.80769"
      />
      <rect
        x="106.609"
        y="-11.4785"
        width="41.5769"
        height="41.5769"
        rx="6.32692"
        transform="rotate(6 106.609 -11.4785)"
        stroke="url(#paint4_linear_198_2404)"
        strokeWidth="1.80769"
      />
    </g>
    <g opacity="0.3">
      <rect
        x="153.746"
        y="-7.43311"
        width="43.3846"
        height="43.3846"
        rx="7.23077"
        transform="rotate(6 153.746 -7.43311)"
        fill="#9AA2B2"
      />
      <rect
        x="153.746"
        y="-7.43311"
        width="43.3846"
        height="43.3846"
        rx="7.23077"
        transform="rotate(6 153.746 -7.43311)"
        fill="url(#paint5_linear_198_2404)"
      />
    </g>
    <g opacity="0.3">
      <rect
        x="202.491"
        y="-1.40091"
        width="41.5769"
        height="41.5769"
        rx="6.32692"
        transform="rotate(6 202.491 -1.40091)"
        stroke="#9AA2B2"
        strokeWidth="1.80769"
      />
      <rect
        x="202.491"
        y="-1.40091"
        width="41.5769"
        height="41.5769"
        rx="6.32692"
        transform="rotate(6 202.491 -1.40091)"
        stroke="url(#paint6_linear_198_2404)"
        strokeWidth="1.80769"
      />
    </g>
    <rect
      x="249.627"
      y="2.64453"
      width="43.3846"
      height="43.3846"
      rx="7.23077"
      transform="rotate(6 249.627 2.64453)"
      fill="#9AA2B2"
    />
    <rect
      x="249.627"
      y="2.64453"
      width="43.3846"
      height="43.3846"
      rx="7.23077"
      transform="rotate(6 249.627 2.64453)"
      fill="url(#paint7_linear_198_2404)"
    />
    <path
      opacity="0.4"
      d="M269.793 13.5495C270.476 13.6204 271.081 13.6831 271.63 13.9451C271.743 13.9991 271.853 14.0592 271.959 14.125C272.477 14.4444 272.859 14.9196 273.29 15.4565L278.417 21.8211C278.918 22.4413 279.363 22.9917 279.563 23.6716C279.763 24.3516 279.688 25.0571 279.603 25.852L279.578 26.0897C279.4 27.7846 279.311 28.6321 278.729 29.1032C278.147 29.5744 277.299 29.4854 275.604 29.3072L261.821 27.8586C260.127 27.6804 259.279 27.5913 258.808 27.0094C258.337 26.4275 258.426 25.58 258.604 23.8851L258.767 22.3301C258.96 20.492 259.116 19.01 259.377 17.8452C259.647 16.64 260.059 15.6264 260.862 14.8155C261.157 14.5178 261.482 14.2527 261.833 14.0246C262.789 13.4032 263.861 13.2093 265.09 13.1944C266.277 13.18 267.965 13.3573 269.793 13.5495Z"
      fill="white"
    />
    <path
      d="M261.333 29.6247C262.987 29.7987 264.188 31.2811 264.014 32.9358C263.84 34.5907 262.358 35.791 260.703 35.6171L259.504 35.4912L259.284 37.589C259.232 38.0854 258.787 38.446 258.29 38.3938C257.794 38.3414 257.434 37.8963 257.486 37.4L258.242 30.2092C258.294 29.7129 258.739 29.3523 259.235 29.4042L261.333 29.6247ZM268.224 30.3491C270.045 30.5405 271.365 32.1715 271.173 33.9917L270.921 36.3887C270.73 38.2089 269.1 39.5299 267.28 39.3386L265.482 39.1497C264.985 39.0975 264.625 38.6523 264.677 38.1558L265.433 30.965C265.485 30.4685 265.93 30.108 266.427 30.1601L268.224 30.3491ZM277.812 31.3568C278.309 31.409 278.669 31.8542 278.617 32.3507C278.565 32.847 278.12 33.2067 277.623 33.1545L274.627 32.8396C274.462 32.8223 274.314 32.9428 274.296 33.1083L274.139 34.6059L276.835 34.8892C277.332 34.9414 277.692 35.3867 277.64 35.8831C277.588 36.3795 277.143 36.7391 276.646 36.687L273.95 36.4036L273.667 39.1007C273.614 39.5971 273.169 39.9576 272.673 39.9055C272.176 39.8533 271.817 39.4081 271.869 38.9117L272.499 32.9193C272.621 31.761 273.658 30.9202 274.816 31.0419L277.812 31.3568ZM266.569 37.4454L267.469 37.5399C268.296 37.6268 269.037 37.027 269.124 36.1997L269.376 33.8028C269.463 32.9754 268.863 32.2338 268.036 32.1468L267.136 32.0523L266.569 37.4454ZM259.693 33.6934L260.892 33.8194C261.554 33.889 262.147 33.4088 262.216 32.7469C262.286 32.0851 261.806 31.492 261.144 31.4224L259.945 31.2965L259.693 33.6934ZM270.871 13.7005C271.136 13.7563 271.388 13.8329 271.629 13.9482C271.742 14.0021 271.852 14.0623 271.959 14.1281C272.477 14.4475 272.859 14.9232 273.29 15.4601L278.417 21.8238C278.918 22.4439 279.362 22.9946 279.562 23.6744C279.651 23.9741 279.686 24.279 279.69 24.5941L277.315 24.3445C275.676 24.1723 274.899 24.0894 273.874 23.8405C272.811 23.5821 271.935 23.1768 271.289 22.3797C270.644 21.5825 270.429 20.6413 270.398 19.5473C270.367 18.4957 270.448 17.719 270.62 16.0868L270.871 13.7005Z"
      fill="white"
    />
    <rect
      x="4.88354"
      y="25.3915"
      width="43.3846"
      height="43.3846"
      rx="7.23077"
      transform="rotate(6 4.88354 25.3915)"
      fill="#9AA2B2"
    />
    <rect
      x="4.88354"
      y="25.3915"
      width="43.3846"
      height="43.3846"
      rx="7.23077"
      transform="rotate(6 4.88354 25.3915)"
      fill="url(#paint8_linear_198_2404)"
    />
    <path
      opacity="0.4"
      d="M22.5171 42.089C22.141 42.0495 21.78 42.2483 21.6124 42.5873L20.8185 44.1932C19.7409 46.373 19.3088 47.2034 18.6154 47.765C17.922 48.3265 17.0198 48.5765 14.6636 49.1773L12.9278 49.62C12.5613 49.7134 12.2918 50.0252 12.2522 50.4013C12.2127 50.7774 12.4115 51.1384 12.7506 51.306L14.3564 52.0999C16.5362 53.1775 17.3667 53.6096 17.9282 54.303C18.4897 54.9964 18.7397 55.8986 19.3406 58.2548L19.7832 59.9906C19.8767 60.3571 20.1884 60.6266 20.5646 60.6662C20.9407 60.7057 21.3017 60.5069 21.4693 60.1678L22.2631 58.562C23.3408 56.3822 23.7729 55.5517 24.4663 54.9902C25.1597 54.4287 26.0618 54.1787 28.4181 53.5778L30.1539 53.1352C30.5203 53.0417 30.7899 52.73 30.8294 52.3538C30.8689 51.9777 30.6701 51.6167 30.3311 51.4491L28.7252 50.6553C26.5454 49.5776 25.715 49.1455 25.1535 48.4521C24.5919 47.7587 24.3419 46.8566 23.7411 44.5003L23.2984 42.7646C23.205 42.3981 22.8932 42.1285 22.5171 42.089Z"
      fill="white"
    />
    <path
      d="M31.6647 47.2916C32.0407 47.331 32.4018 47.1325 32.5694 46.7936L32.9098 46.1047C33.3923 45.1289 33.5267 44.8998 33.7154 44.7469C33.9041 44.5941 34.1564 44.5096 35.212 44.2404L35.9557 44.0505C36.3221 43.9571 36.5914 43.6453 36.6309 43.2692C36.6703 42.8932 36.4719 42.5321 36.1329 42.3645L35.445 42.0241C34.4684 41.5414 34.2391 41.4073 34.0862 41.2185C33.9333 41.0297 33.8499 40.7775 33.5807 39.7219L33.3908 38.9783C33.2974 38.6119 32.9854 38.3427 32.6094 38.3031C32.2333 38.2635 31.8724 38.4621 31.7048 38.8011L31.3644 39.489C30.8816 40.4655 30.7466 40.6948 30.5578 40.8477C30.3691 41.0004 30.117 41.0843 29.0622 41.3533L28.3176 41.5431C27.9513 41.6366 27.682 41.9485 27.6423 42.3244C27.6028 42.7004 27.8015 43.0614 28.1403 43.2291L28.8292 43.5696C29.8056 44.0523 30.0341 44.1873 30.1869 44.3761C30.3398 44.5648 30.4244 44.8164 30.6935 45.8718L30.8833 46.6164C30.9769 46.9827 31.2887 47.2521 31.6647 47.2916Z"
      fill="white"
    />
    <g opacity="0.3">
      <rect
        x="53.6291"
        y="31.4237"
        width="137.987"
        height="41.5769"
        rx="6.32692"
        transform="rotate(6 53.6291 31.4237)"
        stroke="#9AA2B2"
        strokeWidth="1.80769"
      />
      <rect
        x="53.6291"
        y="31.4237"
        width="137.987"
        height="41.5769"
        rx="6.32692"
        transform="rotate(6 53.6291 31.4237)"
        stroke="url(#paint9_linear_198_2404)"
        strokeWidth="1.80769"
      />
    </g>
    <g opacity="0.3">
      <rect
        x="196.648"
        y="45.5468"
        width="43.3846"
        height="43.3846"
        rx="7.23077"
        transform="rotate(6 196.648 45.5468)"
        fill="#9AA2B2"
      />
      <rect
        x="196.648"
        y="45.5468"
        width="43.3846"
        height="43.3846"
        rx="7.23077"
        transform="rotate(6 196.648 45.5468)"
        fill="url(#paint10_linear_198_2404)"
      />
    </g>
    <g opacity="0.3">
      <rect
        x="245.393"
        y="51.5789"
        width="41.5769"
        height="41.5769"
        rx="6.32692"
        transform="rotate(6 245.393 51.5789)"
        stroke="#9AA2B2"
        strokeWidth="1.80769"
      />
      <rect
        x="245.393"
        y="51.5789"
        width="41.5769"
        height="41.5769"
        rx="6.32692"
        transform="rotate(6 245.393 51.5789)"
        stroke="url(#paint11_linear_198_2404)"
        strokeWidth="1.80769"
      />
    </g>
    <rect
      x="297.569"
      y="7.68335"
      width="91.5897"
      height="91.5897"
      rx="14.4615"
      transform="rotate(6 297.569 7.68335)"
      fill="#4075FF"
    />
    <path
      opacity="0.4"
      d="M340.14 30.7047C341.582 30.8543 342.859 30.9868 344.017 31.54C344.256 31.654 344.488 31.7807 344.713 31.9197C345.806 32.5939 346.612 33.5972 347.522 34.7306L358.346 48.1669C359.403 49.4763 360.342 50.6383 360.765 52.0737C361.187 53.5091 361.028 54.9985 360.849 56.6768L359.925 65.4674C359.451 69.9763 359.069 73.6106 358.387 76.4287C357.678 79.3546 356.566 81.764 354.383 83.541C352.2 85.318 349.625 85.9102 346.631 85.9989C343.747 86.0844 340.131 85.7043 335.646 85.2328C331.16 84.7614 327.185 84.3436 324.382 83.6605C321.471 82.9512 319.075 81.8364 317.31 79.6444C315.544 77.4524 314.958 74.8645 314.873 71.8552C314.791 68.9567 315.173 65.3225 315.647 60.8137L315.647 60.8136L316.863 49.2416L316.863 49.2416C317.271 45.3611 317.6 42.2324 318.15 39.7734C318.72 37.2292 319.589 35.0892 321.285 33.3774C321.908 32.749 322.595 32.1893 323.336 31.7078C325.354 30.3959 327.617 29.9865 330.211 29.9551C332.718 29.9248 336.28 30.2989 340.14 30.7047Z"
      fill="white"
    />
    <path
      d="M347.316 69.8314C348.364 69.9418 349.124 70.8806 349.014 71.9285C348.903 72.9763 347.965 73.7368 346.917 73.6269L326.675 71.4994C325.627 71.3892 324.867 70.4501 324.977 69.4021C325.087 68.3541 326.026 67.5937 327.074 67.7039L347.316 69.8314ZM338.259 58.6466C339.307 58.7568 340.067 59.6958 339.957 60.7438C339.847 61.7918 338.908 62.5522 337.86 62.4421L327.739 61.3783C326.691 61.2682 325.931 60.3291 326.041 59.2811C326.151 58.2331 327.09 57.4727 328.138 57.5828L338.259 58.6466ZM342.416 31.0236C342.975 31.1414 343.508 31.3031 344.017 31.5463C344.255 31.6603 344.488 31.7869 344.713 31.9259C345.806 32.6001 346.612 33.6036 347.522 34.7368L358.345 48.1731C359.403 49.4824 360.342 50.6449 360.764 52.0802C360.95 52.7131 361.024 53.3568 361.032 54.0222L356.02 53.4954C352.56 53.1318 350.919 52.9569 348.756 52.4315C346.511 51.8859 344.663 51.0291 343.3 49.3462C341.937 47.6631 341.483 45.6762 341.416 43.3666C341.352 41.1468 341.524 39.5077 341.887 36.0622L342.416 31.0236Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_198_2404"
        x1="241.241"
        y1="1.86368"
        x2="281.296"
        y2="-82.6957"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8DACFD" />
        <stop offset="1" stopColor="#8DACFD" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_198_2404"
        x1="344.189"
        y1="11.9413"
        x2="395.956"
        y2="-39.8249"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8DACFD" />
        <stop offset="1" stopColor="#8DACFD" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_198_2404"
        x1="3.56312"
        y1="24.6107"
        x2="55.3294"
        y2="-27.1556"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8DACFD" />
        <stop offset="1" stopColor="#8DACFD" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_198_2404"
        x1="51.5043"
        y1="29.6495"
        x2="103.271"
        y2="-22.1168"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8DACFD" />
        <stop offset="1" stopColor="#8DACFD" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_198_2404"
        x1="99.4452"
        y1="34.6883"
        x2="151.211"
        y2="-17.0779"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8DACFD" />
        <stop offset="1" stopColor="#8DACFD" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_198_2404"
        x1="147.386"
        y1="39.7271"
        x2="199.153"
        y2="-12.0392"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8DACFD" />
        <stop offset="1" stopColor="#8DACFD" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_198_2404"
        x1="195.327"
        y1="44.7659"
        x2="247.094"
        y2="-7.00036"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8DACFD" />
        <stop offset="1" stopColor="#8DACFD" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_198_2404"
        x1="243.268"
        y1="49.8047"
        x2="295.034"
        y2="-1.96154"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8DACFD" />
        <stop offset="1" stopColor="#8DACFD" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_198_2404"
        x1="-1.4757"
        y1="72.5517"
        x2="50.2906"
        y2="20.7855"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8DACFD" />
        <stop offset="1" stopColor="#8DACFD" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_198_2404"
        x1="32.3338"
        y1="77.5905"
        x2="61.6418"
        y2="-16.8464"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8DACFD" />
        <stop offset="1" stopColor="#8DACFD" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_198_2404"
        x1="190.288"
        y1="92.7069"
        x2="242.055"
        y2="40.9407"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8DACFD" />
        <stop offset="1" stopColor="#8DACFD" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_198_2404"
        x1="238.229"
        y1="97.7458"
        x2="289.996"
        y2="45.9795"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8DACFD" />
        <stop offset="1" stopColor="#8DACFD" stopOpacity="0" />
      </linearGradient>
      <clipPath id="clip0_198_2404">
        <rect
          width="28.9231"
          height="28.9231"
          fill="white"
          transform="translate(356.984 -27.2719) rotate(6)"
        />
      </clipPath>
    </defs>
  </svg>
);
